/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

(function() {
    var touchingCarousel = false,
      touchStartCoords;

    document.body.addEventListener('touchstart', function(e) {
      if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY
      }
    });

    document.body.addEventListener('touchmove', function(e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      var moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y
      };

      if (Math.abs(moveVector.x) > 7)
        e.preventDefault()

    }, {passive: false});
  })();

if (typeof jQuery != 'undefined') {
	$(document).ready(function(){
      $('.ProductMeta__Description_More_Button').click(function() {
        var call = $(this).attr('data-call');
        var target = $('.ProductMeta__Description_Full[data-callback="' + call + '"]');
        target.slideToggle();
		target.toggleClass('open', 'closed');
        $(this).toggleClass('open');
      });
    });
}

$(document).ready(function(){
  //#shopify-section-1583300147337 a
  $('.MegaMenu__Push:last').on('click', function () {
      window.open("https://un-lined.com", "_blank");
  });

  $('.HorizontalList__Item.main-open').on('click', function() {
    $('#sidebar-menu').attr('aria-hidden', 'false');
    $('html').addClass('no-scroll');
  });

  $('#sidebar-menu .SidebarMenu__Nav--secondary .main-open, .PageOverlay').on('click', function() {
    $('#sidebar-menu').attr('aria-hidden', 'true');
    $('html').removeClass('no-scroll');
    $('.PageOverlay').removeClass('is-visible');
  });


  $('li[data-title="Shop"]').html('<a aria-controls="sidebar-menu" aria-expanded="false" class="Heading u-h6">Shop</a>'); 

  
});


$(document).on('click', '.product-title,.product-card__image', function() {
    sessionStorage.setItem('scrollPosition', $(window).scrollTop());
});


$(document).ready(function() {
    var scrollPosition = sessionStorage.getItem('scrollPosition');

  if ($('.shopify-section--main-collection').length > 0) {

    //console.log(scrollPosition);
   
    if (scrollPosition !== null || scrollPosition !== 0) {
        $(window).scrollTop(parseInt(scrollPosition));
        setTimeout(function() {
            sessionStorage.setItem('scrollPosition', 0);
        }, 2000);
    }
  }

    


});